import { EventLocation } from '../domain/EventLocation';

export enum AppNotificationTypes {
    INFO = 1,
    ERROR = 2,
    APP_ERROR = 3,
    APP_INFO = 4,
    APP_WARN = 5,
    APP_SUCCESS = 6,
}


export class AppNotification {
    title?: string;
    text?: string;
    time?: Date;
    type: AppNotificationTypes = AppNotificationTypes.INFO;
    driverId?: number;
    vehicleId?: number;
    data?: any;
    opts?: any;
}
